import { render, staticRenderFns } from "./del-pwd2-dialog.vue?vue&type=template&id=5bcf7688&scoped=true"
import script from "./del-pwd2-dialog.vue?vue&type=script&lang=js"
export * from "./del-pwd2-dialog.vue?vue&type=script&lang=js"
import style0 from "./del-pwd2-dialog.vue?vue&type=style&index=0&id=5bcf7688&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf7688",
  null
  
)

export default component.exports